module.exports = __webpack_public_path__ + "static/media/img-4.cad0f891.png";